import { HomepageType } from '../generated/graphql';

/**
 * Maps HomepageType enum values to their corresponding route paths
 */
const HOMEPAGE_PATH_MAP: Record<HomepageType, string> = {
  [HomepageType.Analytics]: 'insights',
  [HomepageType.Dashboard]: 'workplace-dashboard',
  [HomepageType.Deliveries]: 'deliveries',
  [HomepageType.MeetingSpaces]: 'meeting-rooms',
  [HomepageType.Office]: 'officeV2',
  [HomepageType.People]: 'people',
  [HomepageType.Schedule]: 'schedule/week',
  [HomepageType.Tickets]: 'tickets',
  [HomepageType.Visitors]: 'visits',
};

/**
 * Hook to get the route path for a given homepage type
 * @param homepage - The homepage type from the HomepageType enum
 * @returns The corresponding route path, or null if homepage is not provided
 */
export const useHomepagePath = (
  homepage: HomepageType | null | undefined
): string | null => {
  if (!homepage) {
    return null;
  }

  return (
    HOMEPAGE_PATH_MAP[homepage] || HOMEPAGE_PATH_MAP[HomepageType.Schedule]
  );
};
